<template>
  <b-modal
      class="emoji-modal"
      v-model="showPopup"
      trap-focus
      animation=""
      :destroy-on-hide="false"
      :can-cancel="['escape', 'outside']"
      scroll="keep"
  >
    <picker
        ref="emojipicker"
        class="emoji-picker"
        :style="{ top: emojiTop + 'px', left: emojiLeft + 'px', height: emojiHeight + 'px' }"
        title=""
        set=""
        :native="true"
        :data="emojis"
        :showSkinTones="true"
        @select="insertEmoji"
        color="#7957D5"

    />
  </b-modal>
</template>

<script>
import data from 'emoji-mart-vue-fast/data/twitter.json'
import {Picker, EmojiIndex} from 'emoji-mart-vue-fast'

import 'emoji-mart-vue-fast/css/emoji-mart.css'

export default {
  name: "EmojiPicker",
  components: {Picker},
  props: {
    'trigger': {
      type: Boolean,
      default: false,
    },
    'pickerTop': {
      type: Number,
      default: 0,
    },
    'pickerLeft': {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      showPopup: false,
      emojis: new EmojiIndex(data),
      emojiTop: 0,
      emojiLeft: 0,
      emojiHeight: 350,
    }
  },

  watch: {
    trigger(val) {
      // if the parent component says to open up
      this.showPopup = val
    },
    showPopup(val) {
      if (!val) { // closing
        this.$emit('hide')
      } else {
        this.emojiTop = this.pickerTop;
        this.emojiLeft = this.pickerLeft;

        let tooLow = (this.emojiTop + this.emojiHeight + 20) - window.innerHeight
        if (tooLow > 0) {
          this.emojiTop -= tooLow
          window.scrollBy(0, tooLow)
        }

        // Focus on the input box. Nexttick doesn't work, but this does reliably...
        setTimeout(() => {
          this.$refs.emojipicker.$el.getElementsByClassName('emoji-mart-search')[0].firstChild.focus()
        }, 0)
      }
    }
  },
  methods: {
    insertEmoji(emoji) {
      this.$emit('selected', emoji);
      this.showPopup = false
    }
  }
}
</script>

<style>
.emoji-picker {
  position: absolute;
}

/* we want to use b-modal as it comes with loads of great stuff like
 scroll locking, escape-to-close - but we dont want a lot of the modal
 properties. This turns off a lot of stuff that makes it 'modally'
 */
.emoji-modal .modal-background {
  opacity: 0;
}

.emoji-modal .modal-content {
  margin: 0;
  max-height: none;
  overflow: initial;
  position: initial;
  width: auto;
}
</style>
